import React from "react";
import PropTypes from "prop-types";
import { Card, Row, Col,Select, Button, message, InputNumber } from "antd";
import BankStatementAnalysisTable from "./bank-statement-analysis-table";
import BankStatementAnalysisList from "./bank-statement-analysis-list";
import { PermissionContextManager } from "hocs";
import { STATE_STATUS } from "constants/state-status";
import { SaveProxy, proxyWrapper } from "utilities/save-proxy";
import memoize from "memoize-one";
import BankStatementAnalyser from "./bank-statement-analyser";
import { UI_PERMISSIONS } from "constants";
import "styles/bank-statement-analysis.css";
import { CaseDetailRecord } from "records/index";

const proxy = new SaveProxy();
const ProxiedLink = proxyWrapper(
    props => (
        <Button
            type={"link"}
            size={"small"}
            onClick={props.onClick}
            disabled={props.disabled}>
            {props.label}
        </Button>
    ),
    {
        count: false
    },
    proxy
);

const selectActiveAccountKey = memoize(
    accounts =>
        (
            (accounts &&
                accounts
                    .toList()
                    .filter(_ => _.is_key_account)
                    .first()) || {
                id: null
            }
        ).id
);

class BankStatementAnalysisTab extends React.Component {
    activeKey = null;
    state = {
        changeTableRowsNumber: false,
        showBankStatementAnalyzer: this.props.use_statement_analyzer,
        updateCibilParamData : []
    };
    componentDidMount() {
        if (
            !this.props.statements ||
            !this.props.statements.getIn([Number(this.activeKey), "status"]) ||
            this.props.statements.getIn([Number(this.activeKey), "status"]) ===
                STATE_STATUS.UNFETCHED
        ) {
            this.props.fetchStatement(
                this.props.caseId,
                Number(this.activeKey)
            );
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.use_statement_analyzer !== this.props.use_statement_analyzer) {
            this.setState({
                showBankStatementAnalyzer: this.props.use_statement_analyzer
            });
        }
        if (
            this.activeKey &&
            (!this.props.statements ||
                !this.props.statements.getIn([
                    Number(this.activeKey),
                    "status"
                ]) ||
                this.props.statements.getIn([
                    Number(this.activeKey),
                    "status"
                ]) === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchStatement(
                this.props.caseId,
                Number(this.activeKey)
            );
        }
    }

    triggerSave() {
        proxy.run();
    }

    proxiedUpdateButton = (
        <ProxiedLink label={"Update"} onClick={this.triggerSave} />
    );
    changeRowNumber = () => {
        let accountId = this.props.accounts.find(_ => _.is_key_account);
        if(!accountId) {
            message.error("There is no Key Account exist. Please select one.");
            return;
        }
        this.setState({
            changeTableRowsNumber: true
        });
        this.props.deleteStatement(this.props.caseId, accountId && accountId.id);
    };
    addNewRows = () =>
        this.setState({
            changeTableRowsNumber: false
        });
    deleteRowsButton = (
        <Button type={"link"} onClick={this.changeRowNumber.bind(null)}>
            Reset
        </Button>
    );

    showAnalyser = () => {
        this.setState({
            showBankStatementAnalyzer: !this.state.showBankStatementAnalyzer
        }, () => {
            let details = this.props.caseDetail.toJS();
            details["use_statement_analyzer"] = this.state.showBankStatementAnalyzer;
            this.props.updateCaseDetail(
                this.props.caseId,
                new CaseDetailRecord(details)
            );
        });
    }

    toggleBankStatementAnalyser = () => {
        return (
            <Button type={"primary"} disabled={this.props.recreditViewOnlyPermission} onClick={this.showAnalyser.bind(null)} className={"mr-5"}>
                {this.state.showBankStatementAnalyzer ? "Manual Bank Statement Analysis" : "Bank Statement Analyser"}
            </Button>
        );
    }
    
    getExtra = () => {
        let extraActions = [this.toggleBankStatementAnalyser()];
        if(
            this.props.BANK_STATEMENT_ANALYSIS_EDIT &&
            this.props.isUserAllowedToEdit
        ) {
            extraActions = [...extraActions, this.proxiedUpdateButton, this.deleteRowsButton];
        }

        return extraActions;
    }

    render() {
        this.activeKey = selectActiveAccountKey(this.props.accounts);
        return (
            <Card
                size={"small"}
                className={!this.props.isSummary ? "padless-card" : "padless-card no-border-transparent border-none-header"}
                title={!this.props.isSummary && "Bank Statement Analysis"}
                extra={
                    this.getExtra()
                }>
                <Row>
                    <Col span={24}>
                        {(this.state.showBankStatementAnalyzer) ?
                            (
                                <BankStatementAnalyser
                                    createRequest={this.props.createRequest}
                                    createProfiosRequest={this.props.createProfiosRequest}
                                    fetchJobsList={this.props.fetchJobsList}
                                    fetchJobsDetails={this.props.fetchJobsDetails}
                                    fetchJobsDetailsPerfios={this.props.fetchJobsDetailsPerfios}
                                    fetchStatementAnalysis={this.props.fetchStatementAnalysis}
                                    fetchStatementAnalysisPerfois={this.props.fetchStatementAnalysisPerfois}
                                    retryAnalysis={this.props.retryAnalysis}
                                    retryAnalysisPerfios={this.props.retryAnalysisPerfios}
                                    caseId={this.props.caseId}
                                    companyId={this.props.companyId}
                                    bankStatementAnalyser={this.props.bankStatementAnalyser}
                                    isSummary={this.props.isSummary}
                                    bankCode={this.props.bankCode}
                                    adminGroup= {this.props.adminGroup}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                />
                            ) :
                            (
                                <Row>
                                    <Col>
                                        <BankStatementAnalysisList
                                            statements={
                                                this.props.statements &&
                                                this.props.statements.getIn([
                                                    this.activeKey,
                                                    "data"
                                                ])
                                            }
                                            isSummary={this.props.isSummary}
                                            styleProp={"analysis"}
                                            isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                            limit={this.props.limit}
                                        />
                                    </Col>
                                    <Col span={24} className={"p-5"}>
                                        {this.props.accounts && !this.props.hideStatement
                                            ? this.props.accounts
                                                .filter(_ => _.is_key_account)
                                                .map(_ => (
                                                    <BankStatementAnalysisTable
                                                        key={String(_.id)}
                                                        editable={
                                                            this.props
                                                                .BANK_STATEMENT_ANALYSIS_EDIT
                                                        }
                                                        isCreateStatement={this.props.isCreateStatement}
                                                        isRiskApprover={this.props.isRiskApprover}
                                                        hideColumnSelector={this.props.hideColumnSelector}
                                                        create={
                                                            this.props.isCreateStatement &&
                                                            this.props.createStatement &&
                                                            this.props.createStatement.bind(
                                                                null,
                                                                this.props.caseId,
                                                                Number(_.id)
                                                            )
                                                        }
                                                        update={
                                                            this.props.updateStatement &&
                                                            this.props.updateStatement.bind(
                                                                null,
                                                                this.props.caseId,
                                                                Number(_.id)
                                                            )
                                                        }
                                                        changeTableRows={
                                                            this.state.changeTableRowsNumber
                                                        }
                                                        changeRowNumber={this.changeRowNumber}
                                                        status={
                                                            this.props.statements &&
                                                            this.props.statements.getIn([
                                                                Number(this.activeKey),
                                                                "status"
                                                            ])
                                                        }
                                                        statement={
                                                            this.props.statements &&
                                                            this.props.statements.getIn([
                                                                Number(this.activeKey),
                                                                "data"
                                                            ])
                                                        }
                                                        type={this.props.type}
                                                        proxy={proxy}
                                                        isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                                    />
                                                ))
                                                .toList()
                                            : []}
                                    </Col>
                                  
                                </Row>
                            )}
                                                </Col>
                </Row>
            </Card>
        );
    }
}

BankStatementAnalysisTab.propTypes = {
    Summary: PropTypes.bool,
    companyId: PropTypes.number,
    caseId: PropTypes.number,
    statements: PropTypes.object,
    accounts: PropTypes.object,
    createStatement: PropTypes.func,
    isCreateStatement: PropTypes.bool,
    fetchStatement: PropTypes.func,
    updateStatement: PropTypes.func,
    limit: PropTypes.number,
    type: PropTypes.string,
    deleteStatement: PropTypes.func,
    hideStatement: PropTypes.bool,
    styleProp: PropTypes.string,
    BANK_STATEMENT_ANALYSIS_EDIT: PropTypes.bool,
    hideColumnSelector: PropTypes.bool,
    isRiskApprover: PropTypes.bool,
    isSummary: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool,
    lendingPartner: PropTypes.number,
    createRequest: PropTypes.func,
    createProfiosRequest: PropTypes.func,
    fetchJobsList: PropTypes.func,
    fetchJobsDetails: PropTypes.func,
    fetchJobsDetailsPerfios: PropTypes.func,
    fetchStatementAnalysis: PropTypes.func,
    fetchStatementAnalysisPerfois: PropTypes.func,
    retryAnalysis: PropTypes.func,
    retryAnalysisPerfios: PropTypes.func,
    bankStatementAnalyser: PropTypes.object,
    use_statement_analyzer: PropTypes.bool,
    updateCaseDetail: PropTypes.func,
    caseDetail: PropTypes.object,
    adminGroup: PropTypes.object,
    bankCode: PropTypes.string,
    recreditViewOnlyPermission: PropTypes.bool,
    updateCibilParameter: PropTypes.func
};

BankStatementAnalysisTab.defaultProps = {
    hideColumnSelector: false,
    isCreateStatement: true,
    isSummary: false
};

export default PermissionContextManager({
    permission: UI_PERMISSIONS.BANK_STATEMENT_ANALYSIS_VIEW,
    propsPermissions: {
        BANK_STATEMENT_ANALYSIS_EDIT:
            UI_PERMISSIONS.BANK_STATEMENT_ANALYSIS_EDIT
    }
})(BankStatementAnalysisTab);
